
    import {Component, Prop, Vue, Watch} from "vue-property-decorator";
    import LoadingOverlay from "../../core/LoadingOverlay.vue";
    import VoucherService from '../../../services/voucher.service'
    import StaticData from "../../../staticdata/staticdata";

    @Component({
      components: {LoadingOverlay},
    })
    export default class EnterVoucherExportDateDialog extends Vue {
  
      private daterules = [
        (v: string) => /^([1-9]|0[1-9]|[12][0-9]|3[01])[-\.]([1-9]|0[1-9]|1[012])[-\.](19|20)\d\d$/.test(v) || 'TT.MM.JJJJ Format',
      ];
  
      private notempty = [
        (v: string) => !!v || 'Feld muss ausgefüllt sein',
      ];
  
      private showOverlay = false;
  
      private menu1 = false;
      private exportFromDatum = new Date().toISOString().substr(0, 10);
      private exportFromDatumFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
  
      private menu2 = false;
      private exportUntilDatum = new Date().toISOString().substr(0, 10);
      private exportUntilDatumFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
  
    
      @Watch('exportFromDatum')
      onPropertyChanged1(value: string, oldValue: string) {
        this.exportFromDatumFormatted = this.formatDate(this.exportFromDatum);
      }
  
      @Watch('exportUntilDatum')
      onPropertyChanged2(value: string, oldValue: string) {
        this.exportUntilDatumFormatted = this.formatDate(this.exportUntilDatum);
      }
  
      private exportVoucherdata(){
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
          this.showOverlay = true;
          VoucherService.exportVoucherTrackingData(this.exportFromDatum, this.exportUntilDatum)
            .then((response: any) => {
  
              this.showOverlay = false;
  
              var file = new Blob([response.data], {type: 'application/vnd.ms-excel'});
  
              var url = URL.createObjectURL(file);
  
              var a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display: none');
              a.setAttribute('target', 'blank');
              a.href = url;
              a.download = "customers.xlsx";
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            });
        }
      }
  
      formatDate(date: any) {
        if (!date) {
          return null;
        }
        const [year, month, day] = date.split('-');
  
        return `${day}.${month}.${year}`;
      }
  
      parseDate(date: any) {
        if (!date) {
          return null;
        }
        const [day, month, year] = date.split('.');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
  
      base64ToArrayBuffer(_base64Str: any) {
        var binaryString = window.atob(_base64Str);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      }
  
    }
  